export default "__VITE_PUBLIC_ASSET__9fbb50a6__"